import { render } from "./FinalizadoresContent.vue?vue&type=template&id=1338e011"
import script from "./FinalizadoresContent.vue?vue&type=script&lang=js"
export * from "./FinalizadoresContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__